export const OperationRecordsRepository = Symbol('OperationRecordsRepository');
